import { render, staticRenderFns } from "./ParametreTravaux.vue?vue&type=template&id=06c7b7b0&scoped=true"
import script from "./ParametreTravaux.vue?vue&type=script&lang=js"
export * from "./ParametreTravaux.vue?vue&type=script&lang=js"
import style0 from "./ParametreTravaux.vue?vue&type=style&index=0&id=06c7b7b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c7b7b0",
  null
  
)

export default component.exports